import { useCurrentUser } from "web/hooks/data"

import ViewerLink from "./ViewerLink"

export default function ContactViewer({ value, showLinkIcon, truncateValue }) {
  const currentUser = useCurrentUser()
  if (!currentUser || currentUser.is_guest) return <span>{value.label}</span>

  return (
    <ViewerLink
      href={`/contacts/all/view/${value.value}`}
      label={value.label}
      showLinkIcon={showLinkIcon}
      truncateValue={truncateValue}
    />
  )
}

ContactViewer.isViewerFor = (x) => x.kind === "Contact"
